
import moment from 'moment'
import { Toast } from 'vant';
import numeral from 'numeral';
import wxuserUtil from "./wxuserUtil";
import ImageResize from 'quill-image-resize';
import VueQuillEditor from 'vue-quill-editor'

VueQuillEditor.Quill.register('modules/ImageResize', ImageResize);

export default (Vue) => {

  Vue.prototype.moment = moment;
  Vue.prototype.$title = Toast;
  Vue.prototype.$loading =(title,mask)=>{
    Toast.loading({message:title||"提交中...",mask: mask||true,});
  }
  Vue.prototype.$clear = (title)=>{
                Toast(title||'成功');
                setTimeout(() => {
                  Toast("").clear();
                }, 300);
  }


  Vue.prototype.$time = (val) => {
    let date = new Date(val);
    let date_value =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " ";
    return date_value.trim();
  };
  //格式化日期
  Vue.prototype.formatDate = function (year, month, day) {
    var y = year;
    var m = month;
    if (m < 10) m = "0" + m;
    var d = day;
    if (d < 10) d = "0" + d;
    return y + "-" + m + "-" + d
  },
    Date.prototype.Format = function (fmt) { //author: meizz
      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }
  //比较日期大小
  Vue.prototype.compareTime = function (beginDate, endDate) {
    var d1 = new Date(beginDate.replace(/\-/g, "\/"));
    var d2 = new Date(endDate.replace(/\-/g, "\/"));

    if (beginDate != "" && endDate != "" && d1 >= d2) {
      // 开始时间大于结束时间
      return false;
    } else {
      return true;
    }
  }
  Vue.prototype.$phones=function(){
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        return 1;
    } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
        return 2;
    } else { //pc
        return 0;
    }
  }()
  var Date_    =  new Date();
  Vue.prototype.$D=Date_;

  Vue.prototype.$numeral = numeral;

  Vue.prototype.$funcKey = wxuserUtil.funcKey;

}




// WEBPACK FOOTER //
// ./src/common/common.js